<template>
  <div class="moneyManage">
    <div class="sellCenter container storeBuyOrder">
      <!-- 顶部钱包start -->
      <div class="moneyManageMainBox">
        <div class="moneyManageMainBoxLeft">
          <div class="moneyManageMainBoxLeftTop">
            {{ balance.balance.toFixed(2).split(".")[0] }}.<span
              class="moneyManageMainBoxLeftTopRight"
              >{{ balance.balance.toFixed(2).split(".")[1] }}</span
            >
          </div>
          <div class="moneyManageMainBoxLeftBottom">余额(元)</div>
        </div>
        <div class="moneyManageMainBoxCenter">
          <div style="width: 500px; height: 100px" ref="chart"></div>
        </div>
        <div class="moneyManageMainBoxRight">
          <el-button
            @click="toStoreRecharge"
            size="small"
            class="mainBtn"
            type="info"
          >
            <span class="iconfont icon-chongzhi-"></span> 充值
          </el-button>
          <el-button
            @click="toStoreWithdrawal"
            size="small"
            class="mainBtn"
            type="info"
            ><span class="iconfont icon-chukou"></span> 提现</el-button
          >
          <!-- <el-button
            @click="toPrepayRecharge"
            size="small"
            class="mainBtn"
            type="info"
            ><span class="iconfont icon-gongyingshangyufukuan"></span>
            预付款</el-button
          > -->
        </div>
      </div>
      <!-- 顶部钱包end -->
      <div ref="headerBtn" class="headerBtn">
        <!-- 顶部按钮start -->
        <div class="tabsContainer">
          <div class="tabsBox">
            <el-tabs type="card" @tab-click="handleChangeType">
              <el-tab-pane label="余额明细"> </el-tab-pane>
              <el-tab-pane label="冻结金额明细"> </el-tab-pane>
            </el-tabs>
            <div class="afterBox"></div>
          </div>
          <div class="getExcell">
            <el-button size="mini" @click="dialogFormVisible = true" type="text"
              >导出订单明细</el-button
            >
          </div>
        </div>
        <!-- 顶部按钮end -->
      </div>
      <div></div>
      <div>
        <el-table
          :data="list"
          border
          highlight-current-row
          v-loading="loading"
          :height="tabHeight"
          size="mini"
          @selection-change="handleSelectionChange"
          :style="{ 'background-color': 'transparent' }"
          :header-cell-style="{ 'background-color': '#f8f8f8' }"
        >
          <el-table-column align="center" label="序号" type="index" width="50">
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="pay_type"
            label="交易类型"
            width="300"
          >
            <div slot-scope="scope">
              <div v-if="index == 1">
                {{ renderFrezName(scope.row) }}
              </div>
              <div v-else>
                {{ scope.row | renderName }}
              </div>
            </div>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="pay_type"
            label="支付方式"
            width="150"
          >
            <div slot-scope="scope">
              {{ renderPayment(scope.row) }}
            </div>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="money"
            label="交易金额(元)"
            width="100"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.money > 0" class="skyblue">
                {{ scope.row.money }}
              </div>
              <div v-else class="red">
                {{ scope.row.money }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            :label="index == 1 ? '冻结金额(元)' : '余额(元)'"
            width="130"
          >
            <template slot-scope="scope">
              <div class="green">
                {{ scope.row.balance }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            align="center"
            width="150"
            label="交易时间"
          >
            <template slot-scope="scope">
              <div v-if="index == 1">
                {{ scope.row.create_time | formateDate }}
              </div>
              <div v-else>
                {{ scope.row.payTime | formateDate }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="150" align="center" label="操作">
            <div slot-scope="scope">
              <div
                v-if="getBtnGroup(scope.row) && getBtnGroup(scope.row).length"
              >
                <el-button
                  v-for="(item, index) in getBtnGroup(scope.row)"
                  :key="index"
                  class="_mini"
                  @click="
                    () => {
                      item.onPress(scope.row);
                    }
                  "
                  type="info"
                  size="mini"
                  >{{ item.label }}</el-button
                >
              </div>
              <div v-else>-</div>
            </div>
          </el-table-column>
        </el-table>
        <!-- 分页start -->
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            layout="total,  prev, pager, next, jumper"
            :total="total || 0"
            :page-size="15"
          >
          </el-pagination>
        </div>
        <!-- 分页end -->
      </div>
    </div>
    <div class="downLoadDialog">
      <!-- 下载dialog   start -->
      <el-dialog
        title="导出明细"
        width="500px"
        :center="true"
        :visible.sync="dialogFormVisible"
      >
        <el-form :model="downloadForm">
          <div class="formInfo">
            <div v-if="formInfo2.visible">
              <i class="el-icon-warning"></i> 请选择时间范围
            </div>
          </div>
          <el-form-item label="导出类型：">
            <el-select
              size="mini"
              v-model="downloadForm.type"
              placeholder="请选择导出类型"
            >
              <el-option label="交易明细" value="交易明细"></el-option>
              <el-option label="收款明细" value="收款明细"></el-option>
              <el-option label="付款明细" value="付款明细"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围：">
            <el-date-picker
              v-model="downloadForm.time"
              type="daterange"
              align="left"
              size="mini"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="downLoadExcel">导出excel</el-button>
        </div>
      </el-dialog>
      <!-- 下载dialog   end -->
    </div>
  </div>
</template>

<script>
import {
  listWalletRecordUrl,
  getStoreAccountUrl,
  accountFrozenListUrl,
  receipt_detail,
  tradeMonthUrl,
  transBilPc,
  baseUrl,
} from "@/api/api";
import { mapState } from "vuex";
export default {
  name: "whitebar",
  data() {
    return {
      tabHeight: "300px",
      list: null,
      selectedList: null,
      loading: false,
      index: "0",
      pageIndex: 0,
      total: 0,
      currentOrder: null,
      formLoading: false,
      balance: {
        balance: 0,
        frozenMoney: 0,
        avl_balance: 0,
      },
      dialogFormVisible: false,
      downloadForm: {
        type: "交易明细",
        time: "",
      },
      formInfo2: {
        visible: false,
        info: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.setTableHeight();
    window.addEventListener("resize", this.setTableHeight);
    this.initData();

    this.initStoreBalance().then(this.initCharts);
  },
  computed: {
    ...mapState(["userInfo", "companyInfo"]),
    getOrderStatus() {
      // alert(this.index);
      switch (this.index) {
        case "0":
          return "";
        case "":
          return "";
        case "1":
          return "1";
        case "2":
          return "2";
        case "3":
          return "3";
        case "4":
          return "4";
        case "5":
          return "12,13";
        case "6":
          return "9,10,11,14,15";
      }
    },
  },
  filters: {
    renderName: function (item) {
      const { trade_type, tradeName, orderId, trade_way } = item;
      // return (trade_type == 6)||(trade_type ==7)? tradeName : `${tradeName}-订单:${orderId}`
      let title = `${tradeName}-订单:${orderId}`;
      switch (trade_way) {
        case 1:
          title = `${tradeName}-订单:${orderId}`;
          break;
        case 2:
          title = `店铺余额提现-${tradeName}`;
          break;
        case 3:
          title = `预付款充值-${tradeName}`;
          break;
        case 4:
          title = `退款-${tradeName}`;
          break;
        case 5:
          title = `余额充值`;
          break;
        case 6:
          title = `个人钱包充值-${tradeName}`;
          break;
        case 7:
          title = `个人钱包提现-${tradeName}`;
          break;
      }
      return title;
    },
  },
  methods: {
    toStoreRecharge() {
      if (this.companyInfo && this.companyInfo.type == 3) {
        this.$alert("个人店铺充值请前往肉联所app内操作");
        return;
      }
      if (this.companyInfo && this.companyInfo.type == 9) {
        this.$alert("养殖户充值请前往肉联所app内操作");
        return;
      }
      this.$router.push({ name: "storeWallateRecharge" });
    },
    toStoreWithdrawal() {
      this.$router.push({ name: "storeWithdrawal" });
    },
    // toPrepayRecharge() {
    //   this.$router.push({ name: "prepayRecharge" });
    // },
    downLoadExcel() {
      if (!this.downloadForm.time) {
        this.formInfo2 = {
          visible: true,
          info: "请选择明细时间范围",
        };
        return;
      } else {
        this.formInfo2 = {
          visible: false,
          info: "",
        };
        this.startDownLoadExcel();
      }
    },
    startDownLoadExcel() {
      let { time, type } = this.downloadForm;
      let startTime = time[0].getTime();
      let endTime = time[1].getTime();
      let access_token = this.userInfo.access_token;
      let storeId = this.userInfo.storeId;

      const URL1 = `${tradeMonthUrl}?type=2&access_token=${access_token}${
        "&store_id=" + storeId
      }&date=${startTime}&endDate=${endTime}`;
      const URL2 = `${receipt_detail}?type=1&access_token=${access_token}&pay_startTime=${startTime}&pay_endTime=${endTime}`;
      const URL3 = `${receipt_detail}?type=2&access_token=${access_token}&pay_startTime=${startTime}&pay_endTime=${endTime}`;

      if (type == "交易明细") {
        window.location.href = URL1;
      } else if (type == "收款明细") {
        window.location.href = URL2;
      } else if (type == "付款明细") {
        window.location.href = URL3;
      }
    },
    renderFrezName(item) {
      const { trade_type, tradeName, orderId, trade_way } = item;
      // return (trade_type == 6)||(trade_type ==7)? tradeName : `${tradeName}-订单:${orderId}`
      let title = `${tradeName}-订单:${orderId}`;
      switch (trade_type) {
        case 1:
          title = `发买单锁定金额`;
          break;
        case 2:
          title = `确认收货后解锁余额`;
          break;
        case 3:
          title = `交易失败,删除买单,休市后解锁发单锁定金额`;
          break;
        case 4:
          title = `售出商品订单未确定锁定金额`;
          break;
        case 5:
          title = `客户充值未解锁金额`;
          break;
        case 6:
          title = `客户充值解锁金额`;
          break;
        case 7:
          title = `客户解锁店铺预付款金额`;
          break;
        case 8:
          title = `客户开市订单下单支付成功解锁冻结金额`;
          break;
      }
      return title;
    },
    renderPayment(item) {
      const { pay_type } = item;
      const payTypeMsg = {
        1: "农行支付",
        2: "银行卡快捷支付",
        3: "mpos支付",
        4: "余额支付",
        5: "预存款支付",
        6: "货到付款",
        7: "PC端网银支付",
        8: "个人余额支付",
        9: "小程序余额支付",
      };
      return payTypeMsg[pay_type] || "";
    },
    initStoreBalance() {
      return new Promise((resolve, reject) => {
        let data = {
          access_token: this.userInfo.access_token,
          store_id: this.userInfo.storeId,
        };

        let param = new URLSearchParams();

        for (var k in data) {
          param.append(k, data[k]);
        }

        this.$axios({
          method: "post",
          data: param,
          url: getStoreAccountUrl,
        })
          .then((res) => {
            this.formLoading = false;
            if (res.data.resultCode == 1) {
              console.log("res.data", res.data);
              let {
                balance,
                frozenMoney,
                withdrawalMoney,
                avl_balance,
              } = res.data.data;
              this.balance = {
                balance,
                frozenMoney,
                avl_balance,
              };
              resolve();
            } else {
              this.$alert(`${res.data.resultMsg}`, "提示", {
                confirmButtonText: "确定",
              });
              resolve();
            }
          })
          .catch((error) => {
            this.formLoading = false;
            this.$alert("请求异常:" + error, "提示", {
              confirmButtonText: "确定",
            });
            resolve();
          });
      });
    },
    initCharts() {
      let myChart = this.$echarts.init(this.$refs.chart, "shine");
      // 绘制图表
      let { avl_balance, frozenMoney } = this.balance;

      myChart.setOption({
        legend: {
          orient: "vertical",
          left: 0,
          data: ["可用余额", "冻结金额"],
        },
        series: [
          {
            name: "企业余额",
            color: ["#67aced", "#5fcad2"],
            type: "pie",
            radius: ["40px", "25px"],
            center: ["230px", "50px"],
            avoidLabelOverlap: false,
            label: {
              formatter: "{c}元",
            },
            labelLine: {
              show: true,
              length: "20px",
              length2: "10px",
              lineStyle: {
                color: "#009e96",
              },
            },
            data: [
              {
                value: avl_balance || 0,
                name: "可用余额",
              },
              {
                value: frozenMoney || 0,
                name: "冻结金额",
              },
            ],
          },
        ],
      });
    },
    downloaindPdf({ orderId, type }) {
      this.loading = true;
      let url = transBilPc;
      let data = {
        access_token: this.userInfo.access_token,
        order_id: orderId,
        type: 2,
      };

      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          this.loading = false;
          console.log(res);
          if (res.data.resultCode == 1) {
            if (!res.data.data[0]) {
              this.$alert("暂无法获取该订单电子回单信息", "提示");
              return;
            }
            window.open(
              `${baseUrl}/transbill/order/${res.data.data[0]}`,
              "_blank"
            );
          } else {
            this.$alert(res.data.resultMsg, { center: true, showClose: false });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$alert(JSON.stringify(err));
        });
    },

    getBtnGroup(item) {
      const {
        o_status,
        id,
        type,
        orderId,
        confirmTime,
        updateTime,
        trade_type,
      } = item;
      switch (trade_type) {
        case 7:
          return [
            {
              label: "电子回单",
              onPress: () => {
                if (!orderId) {
                  this.$alert("此提现暂无电子回单信息", "提示");
                  return;
                }
                this.downloaindPdf(item);
                // downloadPdf({
                //   access_token: global.userInfo.access_token,
                //   type: 1,
                //   order_id: order_id,
                // });
              },
            },
            // { label: '评价', onPress: this.comment }
          ];
      }
      return [];
    },

    handleCurrentChange(e) {
      console.log(e);
      this.pageIndex = e - 1;
      setTimeout(() => {
        this.initData();
      });
    },
    formateTotalMoney(item) {
      if (item.fm_status == 1) {
        return item.prepayment;
      }
      if (item.fm_status == 2) {
        return (item.totalMoney - item.prepayment).toFixed(2);
      } else {
        return item.totalMoney;
      }
    },

    handleChangeType(e) {
      console.log(e.index);
      this.index = e.index;
      setTimeout(() => {
        this.initData();
      });
    },
    handleSelectionChange(e) {
      this.selectedList = e;
    },
    initData() {
      this.loading = true;
      let that = this;

      console.log("this.userInfo", this.userInfo);
      let data = null;

      if (this.index == 1) {
        data = {
          access_token: this.userInfo.access_token,
          pageIndex: this.pageIndex,
          pageSize: 15,
          store_id: this.userInfo.storeId,
        };
      } else {
        data = {
          access_token: this.userInfo.access_token,
          // pageNum: pageIndex,
          pageNum: this.pageIndex,
          pageSize: 15,
          type: 2,
        };
      }

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({
        method: "post",
        data: param,
        url: this.index == 1 ? accountFrozenListUrl : listWalletRecordUrl,
      })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            console.log("res.data", res.data.data);
            let data1 = res.data.data;
            that.total = res.data.count;
            that.list = JSON.parse(JSON.stringify(data1));
            console.log("that.list", that.list);
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(function (error) {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    setTableHeight() {
      setTimeout(() => {
        let headerBtn = document.getElementsByClassName("headerBtn")[0]
          .offsetHeight;
        let paginationBtn = document.getElementsByClassName("pagination")[0]
          .offsetHeight;
        let moneyManageMainBox = document.getElementsByClassName(
          "moneyManageMainBox"
        )[0].offsetHeight;

        let getExcell = document.getElementsByClassName("getExcell")[0]
          .offsetHeight;

        let tabHeight =
          window.innerHeight -
          headerBtn -
          paginationBtn -
          moneyManageMainBox -
          getExcell -
          110;
        if (tabHeight < 300) {
          tabHeight = 300;
        }
        this.tabHeight = tabHeight + "px";
      }, 200);
    },
  },
};
</script>

<style lang="less" scoped>
.headerBtn {
  margin-bottom: 10px;
  // background-color: red;
}

.container {
  margin: 10px;
}

.pagination {
  margin-top: 10px;
  width: 200px;
  display: flex;
  justify-content: flex-start;
}

.afterBox {
  border-bottom: 1px solid #009e96;
  display: inline;
  width: 500px;
  margin-right: 72px;
  position: relative;
  z-index: 10;
  background-color: #f6f6f6;
}

.tabsBox {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.goodsDetailItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ecf5ff;
  margin-bottom: 10px;
  padding: 10px;
}

.mainBtn {
  border-radius: 2px;
  position: relative;
  width: 80px;
  height: 30px;
  padding: 0;
  margin-right: 20px;
}

.iconfont {
  font-size: 18px;
  vertical-align: text-top;
  color: #fff;
}

.moneyManageMainBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  // justify-content: space-around;
  height: 100px;
  padding: 0 20px 10px;
  min-width: 1000px;
}

.moneyManageMainBoxLeftTop {
  font-size: 30px;
  color: red;
}

.moneyManageMainBoxLeftTopRight {
  font-size: 16px;
  font-weight: 200;
  color: red;
}

.moneyManageMainBoxLeftBottom {
  font-size: 14px;
  color: #545454;
  margin-top: 5px;
}

.moneyManageMainBoxCenter {
  margin-left: 50px;
}

.tabsContainer {
  display: flex;
  flex-direction: row;
}
.formInfo {
  width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 12px;
  color: #009688;

  border-radius: 2px;
  margin-bottom: 10px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/MoneyManage.vue